import { render, staticRenderFns } from "./SupplySuggestion.vue?vue&type=template&id=a9251b12"
import script from "./SupplySuggestion.vue?vue&type=script&lang=js"
export * from "./SupplySuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports